import { when } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link, LinkProps } from 'react-router-dom';
import { NotificationsConstants, PhotoTabConstants as ui } from '../../Config/UIConstants';
import { Notification } from '../../Models/Notification';
import { ActiveTabState, NavigationContainer } from '../../SharedComponents/MainPageWithNavigator/MainPageWithNavigator';
import { NotificationBodyText } from '../../SharedComponents/NotificationBodyText';
import { NotificationTimeText } from '../../SharedComponents/NotificationTimeText';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { LinkArrow } from '../../images/images';
import { colors } from '../../styles/colors';
import { Table } from './Table';

interface IProps extends RouteComponentProps<{}> {
    store: ApplicationStore;
}

@inject('store')
@observer
export class NotificationsPage extends React.Component<IProps> {
    public componentDidMount(): void {
        when(
            () => this.props.store.notificationStore && this.props.store.notificationStore.isReady,
            () => this.props.store.notificationStore.refreshAllNotifications()
        );
    }

    private renderTableRow: React.StatelessComponent<{item: Notification}> = ({item}) => {
        const { icon, text, createdDateTime, isRead } = item;
        const NotificationLink = (props: Partial<LinkProps>) => (
            <Link
                to={item.linkUrl || ''}
                onClick={item.id ? () => this.props.store.notificationStore.markNotificationAsRead(item.id!) : undefined}
                {...props}
            />
        );
        return <React.Fragment>
            <div style={styles.notificationIconContainer}>
                <img style={styles.notificationIcon} src={icon} />
            </div>
            <NotificationLink style={styles.notificationBodyContainer}>
                <NotificationBodyText isBold={!isRead}>{text}</NotificationBodyText>
                {createdDateTime && <NotificationTimeText>{createdDateTime.fromNow()}</NotificationTimeText>}
            </NotificationLink>
            <NotificationLink style={styles.notificationArrowContainer}>
                <img style={styles.notificationArrow} src={LinkArrow} />
            </NotificationLink>
        </React.Fragment>;
    }

    private renderTable() {
        const HeaderCellsComponent = () =>
            <React.Fragment>
                <NotificationBodyText isBold={true} key="type"
                                      style={{...styles.typeHeaderText, ...styles.notificationIconContainer}}>
                    {NotificationsConstants.TYPE_COLUMN}
                </NotificationBodyText>
                <NotificationBodyText isBold={true} key="body" style={styles.notificationBodyContainer}>
                    {NotificationsConstants.BODY_COLUMN}
                </NotificationBodyText>
                <div onClick={() => this.props.store.notificationStore.markAllAsRead()}
                     style={{...styles.notificationArrowContainer, ...styles.markHeaderContainer}}>
                    <NotificationBodyText isBold={true} style={styles.markHeaderText}>
                        {NotificationsConstants.MARK_AS_READ_COLUMN}
                    </NotificationBodyText>
                </div>
            </React.Fragment>;

        const notifications = this.props.store.notificationStore.allNotifications;

        return (
            <Table
                style={styles.table}
                HeaderCellsComponent={HeaderCellsComponent}
                data={notifications.length > 0 ? notifications : [{
                    id: '-1',
                    text: NotificationsConstants.NO_NOTIFICATIONS,
                } as Notification]}
                RowCellsComponent={this.renderTableRow}
                rowStyle={styles.rowStyle}
            />
        );
    }

    public render() {
        if (!this.props.store.notificationStore) {
            return null;
        }
        return (
            <NavigationContainer
                closeButton={{ dark: true, action: () => this.props.history.goBack() }}
                activeTabState={ActiveTabState.NONE} >
                <div style={styles.container}>{this.renderTable()}</div>
            </NavigationContainer>
        );
    }
}

const rowStyle: React.CSSProperties = {
    paddingTop: 17,
    paddingBottom: 22,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: colors.LIGHT_BORDER
};

const styles = {
    container: {
        justifyContent: 'center',
        display: 'flex',
        flex: 1,
        alignSelf: 'stretch'
    } as React.CSSProperties,
    notificationIconContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: 92,
    } as React.CSSProperties,
    notificationIcon: {
        maxHeight: 21,
        maxWidth: 24
    } as React.CSSProperties,
    notificationBodyContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    } as React.CSSProperties,
    notificationArrowContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingLeft: 24,
        paddingRight: 24,
        height: '100%'
    } as React.CSSProperties,
    notificationArrow: {
        width: 5.5,
        height: 9,
    } as React.CSSProperties,
    typeHeaderText: {
        textAlign: 'center'
    } as React.CSSProperties,
    markHeaderContainer: {
    },
    markHeaderText: {
        color: colors.ACTION_GREEN,
        cursor: 'pointer'
    } as React.CSSProperties,
    table: {
        backgroundColor: colors.WHITE,
        marginTop: 30,
        marginBottom: 30,
        boxShadow: '0px 15px 30px 0 rgba(21,0,49,0.075)'
    } as React.CSSProperties,
    rowStyle
};



// WEBPACK FOOTER //
// ./src/Pages/NotificationsPage/NotificationsPage.tsx